import { SummaryMedicalAppealComponent } from './summary-medical-appeal.component';
import { sectionConfiguration } from '@app/helpers/models.helpers';
import { ContinueLabels, CancelLabels } from '@app/models/section.model';

const formValidation = (fb, recordData) => ({data: fb.group(recordData) });

export default sectionConfiguration(SummaryMedicalAppealComponent, formValidation, [], [], {}, {
  hasSummary: false,
  showComments: true,
  showSubmit: false,
  labelContinue: ContinueLabels.FILE_MEDICAL_APPEAL_REQ,
  labelCancel: CancelLabels.CANCEL
});
